import React, { useEffect } from 'react';

const DevelopmentBanner = () => {
  // Sprawdź czy aplikacja działa na localhost
  const isLocalhost = window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname === '0.0.0.0';

  // Dodaj/usuń klasę CSS do body i zmień tytuł strony
  useEffect(() => {
    if (isLocalhost) {
      document.body.classList.add('localhost');
      // Zmień tytuł strony na wersję testową
      document.title = 'TEST FarmManager';
    } else {
      document.body.classList.remove('localhost');
      // Przywróć oryginalny tytuł
      document.title = 'Zarządzanie Gospodarstwem Rolnym';
    }

    // Cleanup przy unmount komponenta
    return () => {
      document.body.classList.remove('localhost');
      document.title = 'Zarządzanie Gospodarstwem Rolnym';
    };
  }, [isLocalhost]);

  // Jeśli nie jest localhost, nie wyświetlaj banera
  if (!isLocalhost) {
    return null;
  }

  return (
    <div style={{
      backgroundColor: '#ff6b35',
      color: 'white',
      padding: '12px 20px',
      marginBottom: '20px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '600',
      textAlign: 'center',
      boxShadow: '0 2px 8px rgba(255, 107, 53, 0.3)',
      border: '1px solid #e55a2b'
    }}>
      <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
      WERSJA TESTOWA - Aplikacja działa w trybie deweloperskim na localhost
      <i className="fas fa-code" style={{ marginLeft: '8px' }}></i>
    </div>
  );
};

export default DevelopmentBanner;
